import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import casjaMiaVideo from '@assets/images/casja-mia.mp4';
import { Box, Flex, Text } from '@radix-ui/themes';
import { Button, HeaderItalic } from '@/components/common';

/** v90 s-youre-in — "You're in." shown after invite code, before onboarding. */
export function YoureInPage() {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();

  return (
    <Box position="relative" height="100%" minHeight="0">
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="absolute inset-0 size-full bg-black object-cover object-center"
        aria-hidden
      >
        <source src={casjaMiaVideo} type="video/mp4" />
      </video>
      {/* v90: to bottom rgba(10,8,20) 0.4 → 0.55@45% → 0.92@80% → 0.97 */}
      <div className="bg-picture-scrim absolute inset-0" aria-hidden />

      <Flex direction="column" minHeight="0" height="100%" px="5" pb="5" position="relative">
        <Flex direction="column" justify="center" flexGrow="1" minHeight="0">
          <HeaderItalic>{t('youreIn.title')}</HeaderItalic>
          <Text as="p" size="2" color="gray" mt="3">
            {t('youreIn.description')}
          </Text>
        </Flex>
        <Button
          type="button"
          onClick={() => navigate('/')}
          color="gray"
          highContrast
          fullWidth
          size="lg"
        >
          {t('youreIn.continue')}
        </Button>
      </Flex>
    </Box>
  );
}
